module.exports = __webpack_public_path__ + "img/logo-dark-short.7d3d8b08.png";